import React, { Component } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { CreateItem } from '../../helpers/crud';
import myFetchWithId from '../../helpers/myFetch';
import Loader from 'react-loader-advanced';

class SaveItem extends Component {
  constructor() {
    super();
    this.state = {
      selected: '尚無建立名單',
      loading :false,
      failAlert:'儲存失敗，請重新嘗試，若仍然無法儲存，請聯絡管理員。',
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.followItem = this.followItem.bind(this);
  }
  handleSelect(event) {
    this.setState({ selected: event.target.value});
  }

  async followItem() {
    this.setState({loading :true})

    if(this.props.savedList.length<1 || this.state.selected === '尚無建立名單'){
      this.setState({resultOpen: true,savedSuccess:false,loading :false,failAlert:"尚無建立名單，請先建立名單後關掉視窗，再重新嘗試 ; 如果已建立新名單，請關掉視窗後再進行儲存。"});
    }else{
      const normalFetch = myFetchWithId('', true, true);
      const getFetch = myFetchWithId('',true)
      const items = this.props.saveObj.doc ? decodeURIComponent(this.props.saveObj.doc).split(',') :[]
      const author = this.props.saveObj.author? decodeURIComponent(this.props.saveObj.author): []
  
      // 過濾重複資料
      let stored_data =[]
      const preStoreData = []
      await getFetch(this.props.getListApi,{id:this.state.selected}).then(data=>{
        if(this.props.title === "作者"){
          const pre_data = data.response_data.filter(item => item.id === this.state.selected)[0].authors.map(item => decodeURIComponent(item.author)).filter(obj => obj === author)
          pre_data.length >0 ? null : stored_data.push(author)
        }
        else if(this.props.title === "文章"){
          let preData = data.response_data.list.map(item => decodeURIComponent(item.doc))
          stored_data = preData.concat(items.filter((obj)=>{ return preData.indexOf(obj) === -1}))
          stored_data = stored_data.filter((e)=>{
            return preData.indexOf(e) === -1
          }).concat(preData.filter((f)=>{
            return stored_data.indexOf(f) === -1
          }))
        }else if(this.props.title === '頻道'){
          const storeData = data.response_data.list
          storeData.forEach(item => {
            preStoreData.push({
              type: item.type || '' ,
              source: item.source || '',
              ch: item.channel || '',
              chKey: item.glb_channel_key || '',
            })
          });
        }
      })
  
      if(this.props.title === '頻道'){
        const combineList = [...new Set(preStoreData.concat(this.props.saveObj).map(item => JSON.stringify(item)))].map(item => JSON.parse(item));
        const newObj = JSON.stringify(combineList)
        const savedItem = {"id": `${this.state.selected}`,"list":`${newObj}`}
        try {
          normalFetch(this.props.addItemApi,savedItem)
          .then( data => {
            if (data.response_status) {
              if (data.response_status==='SUCCESS') {
                this.setState({savedSuccess: true, resultOpen: true,loading :false},()=>this.props.resetState());
              } else {
                this.setState({resultOpen: true,loading :false});
              }
            } else {
              this.setState({
                resultOpen: true,
              });
            }
          })
        } catch (err) {
            this.props.updateError(err);
            this.setState({resultOpen: true});
        }
      }
      // multi store
      else if(stored_data.length>1){
        try {
          Promise.all(stored_data.map((item) => {
            const savedItem = {doc:encodeURIComponent(item), id: this.state.selected}
            // console.log('multi store')
            // console.log(savedItem)
            return normalFetch(this.props.addItemApi,savedItem)})
            ).then( data => {
              let response_status = data.map(item=>item.response_status).find(item => item != 'SUCCESS')
              if (data) {
                if (!response_status) {
                  this.setState({savedSuccess: true, resultOpen: true,loading :false});
                } else {
                  this.setState({resultOpen: true,loading :false});
                }
              } else {
                this.setState({resultOpen: true,loading :false});
              }
            })
        } catch (err) {
            // this.props.updateError(err);
            console.log('err :'+err)
            this.setState({resultOpen: true,loading :false});
        }
      }else{
        // single store
        const savedItem = this.props.title === "作者" ? {author:encodeURIComponent(stored_data[0]), id: this.state.selected} :{doc:encodeURIComponent(stored_data[0]), id: this.state.selected}

        if(savedItem.doc || savedItem.author){
          if(stored_data.length>0){
            console.log('suscceed')
            try {
              normalFetch(this.props.addItemApi,savedItem)
              .then( data => {
                if (data.response_status) {
                  if (data.response_status==='SUCCESS') {
                    this.setState({savedSuccess: true, resultOpen: true,loading :false});
                  } else {
                    this.setState({resultOpen: true,loading :false});
                  }
                } else {
                  this.setState({resultOpen: true});
                }
              })
            } catch (err) {
                this.props.updateError(err);
                this.setState({resultOpen: true});
              }
          }else{
            console.log('blank')
            this.setState({savedSuccess: true, resultOpen: true,loading :false});
          }
        }else{
          console.log('fail')
          this.setState({resultOpen: true,savedSuccess:false,loading :false,failAlert:"尚未選擇任何文章，請選擇文章後再進行儲存。"});
        }
    }  
    }
  }
  
  componentDidMount() {
    this.setState({
      selected: this.props.savedList.length > 0 ? this.props.savedList[0].id ? this.props.savedList[0].id : '尚無建立名單' : '尚無建立名單'
    })
  }
  render() {
    const spinner = <div className="lds-ripple"><div></div><div></div></div>;
    return (
      <div className="popup-modal conceptmap-edit-modal">
      <Loader show={this.state.loading} message={spinner}>
        {this.state.resultOpen ?
          <React.Fragment>
          {
           this.state.savedSuccess ?
             <div className='error-container'>
              <div className='empty-alram'>
                {this.props.title}儲存成功
              </div>
              <div className='popup-modal-buttonset'>
                <button className="apply" onClick={this.props.cancel}>
                  確定
                </button>
              </div>
             </div> :

             <div className='error-container'>
              <div className='empty-alram'>
                {this.props.title}{this.state.failAlert}
              </div>
              <div className='popup-modal-buttonset'>
                <button className="apply" onClick={this.props.cancel}>
                  確定
                </button>
              </div>
             </div>
           }
          </React.Fragment> :
          <React.Fragment>
          <div className="popup-modal-header">
            <h3>儲存{this.props.title}</h3>
          </div>
          <div className="popup-modal-content">
            <Label>選擇一份名單，或
            <CreateItem
              apiCall={this.props.addListApi}
              fetchItem={this.props.refreshAction}
              updateError={this.props.updateError}
              contentText={'請設定此名單的名稱'}
              // addSelect={this.state.addSelect}
            >
              {({toggleNameSet}) => (
                <button className='add' onClick={toggleNameSet}>新增名單</button>
              )}
            </CreateItem>
            來存放此{this.props.title}</Label>
            <Input type="select" id="selectDashboard" onChange={this.handleSelect} value={this.state.selected}>
              {this.props.savedList.map( (ele, index) =>
                <option key={index} value={ele.id}>{decodeURIComponent(ele.name)}</option>
              )}
            </Input>
            <div className="popup-modal-buttonset">
              <button className="apply" onClick={this.followItem}>
                儲存
              </button>
              <button className="cancel" onClick={this.props.cancel}>
                取消
              </button>
            </div>
          </div>
          </React.Fragment>

        }
        </Loader>
      </div>
    );
  }
}
export default SaveItem;



// WEBPACK FOOTER //
// ./src/components/popup/saveItem.js